module.exports = __webpack_public_path__ + "img/logo_morado_celeste.4f240c0d.png";